import { useQuery } from '@tanstack/react-query';
import { searchTalent, type TalentSearchFilters, type TalentSearchResult } from '../api/talentSearch';

export function useTalentSearch(filters: TalentSearchFilters) {
  return useQuery<TalentSearchResult[]>({
    queryKey: ['talent-search', filters],
    queryFn: () => searchTalent(filters),
  });
}
